import produce from 'immer';
import { combineReducers } from 'redux';
import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import {
  ContainerImageActionType,
  ContainerImageAction,
} from '../../actions/containerImageActions';

interface ContainerImageState {
  byId: Record<string, RcInstanceDTO.ContainerImage>;
  allIds: string[];
}

export const initialState: ContainerImageState = {
  byId: {},
  allIds: [],
};

const byId = (state = initialState.byId, action: ContainerImageAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ContainerImageActionType.GET_CONTAINER_IMAGES:
        return {};
      case ContainerImageActionType.GET_CONTAINER_IMAGES_OK: {
        action.data.forEach((containerImage) => {
          draft[containerImage.id] = containerImage;
        });

        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: ContainerImageAction) => {
  switch (action.type) {
    case ContainerImageActionType.GET_CONTAINER_IMAGES:
      return [];
    case ContainerImageActionType.GET_CONTAINER_IMAGES_OK:
      return action.data.map((containerImage) => containerImage.id);
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds });
